import { MisTareas } from './MisTareas/MisTareas';

export const MisTareasContent = () => {
    //Reseteo valores de la calculadora de ESAS
    localStorage.removeItem('esasValues');
    return (
        <MisTareas />
    );
}
